import React from 'react';
import classnames from 'classnames';
import { Translate, withLocalize } from 'react-localize-redux';
import { writeErr } from '../../common/logger';
import { ENTITY_STATE } from '../monitoringConstants';
import { BbSelectNoFormik } from '../../styling/bbInput';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { selectDefaultStyles } from '../../styling/selectDefaultStyles';
import { apiGet, apiPost, getHostApi } from '../../../store/apiWrapper';
import { Circles } from '../../common/loadingComponent';
import LinkButton, { BUTTON_TYPE } from '../../common/linkButton';
import Message from '../../common/message';
import ModalInner from '../../layoutItems/modalInner';
import FixedRightTable from '../../layoutItems/fixedRightTable';
import ResponsiveTable from '../../layoutItems/responsiveTable';
import PerfectScrollbar from 'react-perfect-scrollbar';
import FixedRightTableTools from '../../layoutItems/fixedRightTableTools';
import SharePortfolioConfirmationPopup from './sharePortfolioConfirmationPopup';

import EditIcon from '../../../img/icons/Upravit';
import AddIcon from '../../../img/icons/Plus';
import DeleteIcon from '../../../img/icons/BBiconsOdstranit';
import ToolsIcon from '../../../img/icons/BBicons_Spravovat_portfolio';

import './sharePortfolio.scss';

const buttonType = {
    add: 0,
    edit: 1,
    delete: 2,
    tools: 3
};

class SharePortfolioPopup extends React.Component {
    state = {
        isLoading: false,
        sharedToUsers: [],
        roles: [],
        users: [],
        inserting: 0,
        showConfirmDialog: false,
        error: null
    }

    colWidth = 200;
    rowHeight = 40;

    render() {
        const data = this.state.sharedToUsers.filter(f => f.state !== ENTITY_STATE.removed);
        return (
            <ModalInner close={() => this.props.close()} title={this.props.translate("Monitoring.Share")}>
                {this.state.isLoading && <Circles />}
                {!this.state.isLoading && this.state.error && this.state.error.exception && <Message type="error" options={{ renderInnerHtml: true }}
                    message={this.props.translate(this.state.error.exception, this.getExceptionData(this.state.error.exceptionData))} />}
                {!this.state.isLoading && this.state.showConfirmDialog && <SharePortfolioConfirmationPopup open={true}
                    close={() => this.setState({ showConfirmDialog: false })}
                    ok={() => {
                        this.setState({ showConfirmDialog: false }, this.saveChanges());
                        this.props.close();
                    }}
                    cancel={() => {
                        this.setState({ showConfirmDialog: false }, this.cancelChanges());
                        this.props.close();
                    }}
                />}
                {!this.state.isLoading && <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <div style={{ marginBottom: "1em" }}>
                        <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                            onClick={() => this.addSharing()}
                        >
                            <Translate id="Common.Button.AddUser" />
                        </button>
                    </div>
                    <PerfectScrollbar options={{ suppressScrollX: true }} style={{ height: "18em" }}>
                        <table className="sharing-table table table-report-section">
                            <thead>
                                <tr>
                                    <th><Translate id="Monitoring.Share.Name" /></th>
                                    <th><Translate id="Monitoring.Share.UserName" /></th>
                                    <th><Translate id="Monitoring.Share.Permission" /></th>
                                    <th className='align-right' style={{ width: "10%" }}>
                                        <Translate id="Common.Actions" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((sh, i) => sh.state === ENTITY_STATE.edited || sh.state === ENTITY_STATE.inserted ? this.renderEditRow(sh) : this.renderRow(sh))}
                            </tbody>
                        </table>
                    </PerfectScrollbar>
                    {this.anyChanges() &&
                        <div className='modal-inner-buttons'>
                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.saveChanges()} disabled={this.saveDisabled()}><Translate id="Common.Button.Save" /></button>
                        </div>}
                    {/* <div className="hide-on-desktop">
                        <div style={{ marginBottom: "1.5em" }}>
                            <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.addSharing()}><Translate id="Common.Button.AddUser" /></button>
                        </div>
                        <FixedRightTable
                            leftData={this.leftData(data)} rightData={this.rightData(data)}
                            leftHeader={this.leftHeader()} rightHeader={[[<div />]]} additionalHeight={this.calculateAdditionalHeight}
                            rowHeight={this.rowHeight} maxWidth={3 * this.colWidth + 100} leftColumnWidth={this.leftColumnWidth} rightColumnWidth={125} center
                        />
                        <div style={{ display: "flex", flexDirection: "column", paddingTop: "2em", width: "100%" }}>
                            <div className="sharing-btn-container-mobile">
                                {this.anyChanges() ? <>
                                    <div style={{ width: "50%" }}>
                                        <button className={classnames('bb-button is-primary gradient-1 sharing-btn-mobile', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.saveChanges()} disabled={this.saveDisabled()}>
                                            <Translate id="Common.Button.Save" />
                                        </button>
                                    </div>
                                </> : null}
                            </div>
                        </div>
                    </div> */}
                </div>}
            </ModalInner>
        )
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        apiGet(`${getHostApi()}/api/portfolio/${this.props.portfolioId}/share`, null,
            (s) => {
                if (s.data.isSuccess) {
                    this.setState({
                        isLoading: false,
                        sharedToUsers: s.data.sharing || [],
                        roles: s.data.roles || [],
                        users: s.data.users || []
                    });
                } else
                    this.setState({ isLoading: false, error: { exception: s.data.exception, exceptionData: this.getExceptionData(s.data.exceptionData) } });
            },
            (e) => writeErr(e)
        );
    }

    renderRow = (sharing) => {
        const role = this.state.roles.find(f => f.id === sharing.role);
        return (
            <tr key={sharing.id} style={{ lineHeight: "2em" }}>
                <td>{sharing.name}</td>
                <td>{sharing.userName}</td>
                <td>{isNullOrUndefined(role) ? null : role.name}</td>
                <td className="sharing-row-buttons">
                    {sharing.isOwner ? null : this.createLink(buttonType.edit, sharing)}
                    {sharing.isOwner ? null : this.createLink(buttonType.delete, sharing)}
                </td>
            </tr>
        )
    }

    renderEditRow = (sharing) => {
        const role = this.state.roles.find(f => f.id === sharing.role);
        const users = sharing.state === ENTITY_STATE.edited
            ? [{ userId: sharing.userId, name: sharing.name, userName: sharing.userName }, ...this.getUsers()] : this.getUsers();
        var style = selectDefaultStyles;
        style.menuPortal = base => ({ ...base, zIndex: 99999999 });
        return (
            <tr key={sharing.id} style={{ lineHeight: "2.6em" }}>
                <td colSpan={2} className="sharing-select">
                    <BbSelectNoFormik
                        options={users.map(u => this.createUserLabel(u))}
                        placeholder={`${this.props.translate("Common.User")}...`}
                        onChange={(input, _) => this.updateSharing(sharing.id, input.value, true)}
                        defaultValue={sharing.state === ENTITY_STATE.edited ? this.createUserLabel(sharing) : undefined}
                        isFixed={true}
                        style={style}
                    />
                </td>
                <td className="sharing-select">
                    <BbSelectNoFormik
                        options={this.state.roles.map(r => this.createRoleLabel(r))}
                        placeholder={`${this.props.translate("Monitoring.Share.Permission")}...`}
                        onChange={(input, _) => this.updateSharing(sharing.id, input.value, false)}
                        defaultValue={sharing.state === ENTITY_STATE.inserted || isNullOrUndefined(role) ? undefined : this.createRoleLabel(role)}
                        isFixed={true}
                        style={style}
                    />
                </td>
                <td className="sharing-row-buttons">
                    {sharing.isOwner ? null : this.createLink(buttonType.delete, sharing)}
                </td>
            </tr>
        );
    }

    addSharing = () => {
        this.setState({
            inserting: this.state.inserting - 1,
            sharedToUsers: [
                ...this.state.sharedToUsers,
                { id: this.state.inserting - 1, userId: -1, role: -1, userName: null, name: null, isOwner: false, state: ENTITY_STATE.inserted },
            ]
        })
    }

    editSharing = (sharing) => {
        this.setState({
            sharedToUsers: this.state.sharedToUsers.map(s => s.id === sharing.id
                ? { ...s, originalValues: { userId: s.userId, name: s.name, userName: s.userName, role: s.role }, state: ENTITY_STATE.edited } : s)
        });
    }

    removeSharing = (sharing) => {
        if (sharing.id < 0)
            this.setState({
                sharedToUsers: this.state.sharedToUsers.filter(s => { return s.id !== sharing.id })
            });
        else
            this.setState({ sharedToUsers: this.state.sharedToUsers.map(s => sharing.id === s.id ? { ...s, state: ENTITY_STATE.removed } : s) });
    }

    saveChanges = () => {
        apiPost(`${getHostApi()}/api/portfolio/${this.props.portfolioId}/share/update`, {}, this.state.sharedToUsers,
            (s) => {
                if (s.data.isSuccess) {
                    this.setState({
                        inserting: 0,
                        sharedToUsers: this.state.sharedToUsers.map(x => {
                            if (x.state === ENTITY_STATE.loaded)
                                return x;
                            const modified = s.data.sharingResults.find(f => f.sharingId === x.id && f.success);
                            if (x.state === ENTITY_STATE.inserted)
                                return (!isNullOrUndefined(modified)) ? { ...x, state: ENTITY_STATE.loaded, id: modified.newId } : null;
                            else if (x.state === ENTITY_STATE.edited)
                                return (!isNullOrUndefined(modified))
                                    ? { id: x.id, userId: x.userId, role: x.role, userName: x.userName, name: x.name, isOwner: x.isOwner, state: ENTITY_STATE.loaded }
                                    : {
                                        id: s.id, userId: s.originalValues.userId, name: s.originalValues.name, userName: s.originalValues.userName,
                                        role: s.originalValues.role, isOwner: s.isOwner, state: ENTITY_STATE.loaded
                                    };
                            else if (x.state === ENTITY_STATE.removed)
                                return (!isNullOrUndefined(modified)) ? null : { ...x, state: ENTITY_STATE.loaded };
                        }).filter(fn => !isNullOrUndefined(fn))
                    })
                } else
                    this.setState({ error: { exception: s.data.exception, exceptionData: this.getExceptionData(s.data.exceptionData) } });
            },
            (e) => writeErr(e)
        );
    }

    cancelChanges = () => {
        this.setState({
            inserting: 0,
            sharedToUsers: this.state.sharedToUsers.filter(f => f.state !== ENTITY_STATE.inserted).map(s => {
                if (s.state === ENTITY_STATE.edited)
                    return {
                        id: s.id, userId: s.originalValues.userId, name: s.originalValues.name, userName: s.originalValues.userName, role: s.originalValues.role,
                        isOwner: s.isOwner, state: ENTITY_STATE.loaded
                    };
                else if (s.state === ENTITY_STATE.removed)
                    return { ...s, state: ENTITY_STATE.loaded };
                else
                    return s;
            })
        })
    }

    updateSharing = (sharingId, value, isUser) => {
        const data = isUser ? this.state.users.find(f => f.userId === value) : value
        this.setState({
            sharedToUsers: this.state.sharedToUsers.map(s => {
                if (s.id === sharingId) {
                    if (isUser)
                        return { ...s, userId: data.userId, userName: data.userName, name: data.name }
                    else
                        return { ...s, role: data }
                }
                return s;
            })
        });
    }

    close = () => {
        if (this.anyChanges())
            this.setState({ showConfirmDialog: true });
        else
            this.props.close();
    }

    getUsers = () => this.state.users.filter(f => !this.state.sharedToUsers.map(sh => sh.userId).includes(f.userId)).sort((a, b) => {
        const upA = a.name.toUpperCase();
        const upB = b.name.toUpperCase();
        if (upA < upB) return -1;
        if (upA > upB) return 1;
        return 0;
    });

    leftHeader() {
        return [[
            <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
                <div className="sharing-cell-mobile bold" style={this.firstCollCellStyle}><Translate id="Monitoring.Share.Name" /></div>
                <div className="sharing-cell-mobile bold" style={this.firstCollCellStyle}><Translate id="Monitoring.Share.UserName" /></div>
            </div>,
            <div className="bold"><Translate id="Monitoring.Share.Permission" /></div>
        ]];
    }

    leftData(data) {
        return [...data.map(d => d.state === ENTITY_STATE.edited || d.state === ENTITY_STATE.inserted ? this.leftEditRowData(d) : this.leftRowData(d))];
    }

    leftRowData(sharing) {
        return [
            <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
                <div className="sharing-cell-mobile bold">{sharing.name}</div>
                <div className="sharing-cell-mobile">{sharing.userName}</div>
            </div>,
            <div className="sharing-cell-mobile">{this.getRoleName(sharing.role)}</div>
        ];
    }

    leftEditRowData(sharing) {
        const role = this.state.roles.find(f => f.id === sharing.role);
        const users = sharing.state === ENTITY_STATE.edited
            ? [{ userId: sharing.userId, name: sharing.name, userName: sharing.userName }, ...this.getUsers()] : this.getUsers();

        return [
            <div className="sharing-cell-mobile">
                <BbSelectNoFormik
                    options={users.map(u => this.createUserLabel(u))}
                    selectPlaceholder={`${this.props.translate("Common.User")}...`}
                    styles={{ menuList: (base) => ({ ...base, lineHeight: "17px", height: "100px" }), control: (base) => ({ ...base, borderColor: "#14B8B0" }) }}
                    onChange={(input, _) => this.updateSharing(sharing.id, input.value, true)}
                    classNamePrefix="sharing-select-user"
                    isSearchable={true}
                    defaultValue={sharing.state === ENTITY_STATE.edited ? this.createUserLabel(sharing) : undefined}
                />
            </div>,
            <div className="sharing-cell-mobile">
                <BbSelectNoFormik
                    classNamePrefix="sharing-select-role"
                    styles={{ menuList: (base) => ({ ...base, lineHeight: "17px", height: "100px" }), control: (base) => ({ ...base, borderColor: "#14B8B0" }) }}
                    options={this.state.roles.map(r => this.createRoleLabel(r))}
                    isSearchable={true}
                    selectPlaceholder={`${this.props.translate("Common.Select")}...`}
                    onChange={(input, _) => this.updateSharing(sharing.id, input.value, false)}
                    defaultValue={sharing.state === ENTITY_STATE.inserted || isNullOrUndefined(role) ? undefined : this.createRoleLabel(role)}
                />
            </div>
        ];
    }

    rightData(data) {
        return data.map(d => [
            <div className="sharing-cell-mobile" style={{ paddingLeft: "5px" }}>
                {!d.isOwner && this.generateContextMenu(d, d.state !== ENTITY_STATE.edited)}
            </div>]
        );
    }

    generateContextMenu = (sharing, editBtn = true, deleteBtn = true) => {
        const buttons = [];
        if (editBtn)
            buttons.push({ item: this.createButton(buttonType.edit), action: () => this.editSharing(sharing) });
        if (deleteBtn)
            buttons.push({ item: this.createButton(buttonType.delete), action: () => this.removeSharing(sharing) });

        return (
            <FixedRightTableTools content={this.createButton(buttonType.tools)}
                id={`sharing-${sharing.id}`} contentWidth={250} mode="none" style={{ float: "none" }} buttons={buttons} buttonClassName="sharing-context-btn"
                menuStyle={{ position: "absolute", left: "-105px", width: "15em" }} buttonStyle={{ width: "100%", textAlign: "left" }}
            />
        );
    }

    anyChanges = () => this.state.sharedToUsers.filter(f => f.state !== ENTITY_STATE.loaded).length > 0;
    saveDisabled = () => {
        var editing = this.state.sharedToUsers.filter(f => f.state !== ENTITY_STATE.loaded);
        return editing.filter(f => f.userId === -1).length > 0 || editing.filter(f => f.role === -1).length > 0;
    }

    createUserLabel(u) { return { label: `${u.name} (${u.userName})`, value: u.userId, key: u.userId }; }
    createRoleLabel(r) { return { label: r.name, value: r.id, key: r.id }; }
    getRoleName(roleId) {
        var role = this.state.roles.find(f => f.id === roleId);
        return isNullOrUndefined(role) ? null : role.name;
    }

    leftColumnWidth = (col) => {
        switch (col) {
            case 0: return 2 * this.colWidth;
            default: return this.colWidth;
        }
    }

    calculateAdditionalHeight = () => {
        const lastIdx = this.state.sharedToUsers.length - 1;
        if (lastIdx < 0)
            return 0;
        let maxIter = 3;
        if (lastIdx < maxIter)
            maxIter = lastIdx + 1;
        for (let i = 0; i < maxIter; ++i) {
            const s = this.state.sharedToUsers[lastIdx - i].state;
            if (s === ENTITY_STATE.edited || s === ENTITY_STATE.inserted)
                return this.rowHeight * (maxIter - i);
        }
        return 0;
    }

    createLink = (type, sharing) => {
        switch (type) {
            case buttonType.edit:
                return <LinkButton type={BUTTON_TYPE.edit} onClick={() => this.editSharing(sharing)} />;
            case buttonType.delete:
                return <LinkButton type={BUTTON_TYPE.remove} onClick={() => this.removeSharing(sharing)} />;
            default:
                return null;
        }
    }

    createButton = (type, options = {}) => {
        let Icon, label;
        switch (type) {
            case buttonType.add:
                Icon = AddIcon;
                label = this.props.translate("Common.Button.AddUser");
                break;
            case buttonType.edit:
                Icon = EditIcon;
                label = this.props.translate("Common.Button.Edit");
                break;
            case buttonType.delete:
                Icon = DeleteIcon;
                label = this.props.translate("Common.Button.Delete");
                break;
            case buttonType.tools:
                Icon = ToolsIcon;
                label = this.props.translate("Common.Button.Tools");
                break;
            default:
                return null;
        }

        const defaultSize = 1.25;
        const size = isNullOrUndefined(options) ? defaultSize : options.size || defaultSize;
        const style = isNullOrUndefined(options) ? undefined : options.style;

        return <div className="sharing-btn" style={style}>
            <Icon fill="#14B8B0" style={{ width: `${size}em`, height: `${size}em` }} />
            <div style={{ height: "100%" }}>
                <span style={{ verticalAlign: "middle" }}>{label}</span>
            </div>
        </div>
    }

    getExceptionData = (e) => isNullOrUndefined(e) ? undefined : e;
}

export default withLocalize(SharePortfolioPopup);